import { Order, ORDER_SOURCE_IDS } from "@/pages/Orders/orders.types";
import { LcrOrder, LCR_STATUS_LABELS } from "./lcr-order.types";

const REPLACEMENT_ITEM_NAME = "Replacement laptop";

export const toOrder = (lcr: LcrOrder): Order => ({
  orderId: lcr.orderId,
  orderReference: lcr.orderId,
  source: ORDER_SOURCE_IDS.lcr,
  deliveryMethod: lcr.submission.deliveryMethod,
  status: LCR_STATUS_LABELS[lcr.lcrStatus],
  requested: { on: lcr.acceptedAt },
  items: [{ itemId: lcr.serialNumber, itemInformation: { name: `${lcr.selectedDevice.make} ${lcr.selectedDevice.model}`.trim() || REPLACEMENT_ITEM_NAME } }],
});
